import React from 'react';
import { useHistory } from 'react-router';
import styled, { css } from 'styled-components';
import { Modal, Button } from 'fpay-ui';
import { FORGOT_PASSWORD } from '@constants/routes';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { useAuth } from '@hooks';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const Container = styled.div(
  ({ theme }) => css`
    display: block;
    text-align: center;
    justify-content: center;
    padding: 56.3px 4px 32px 4px;
    height: 100%;
    width: 100%;
    margin: auto;
    ${theme.breakpoint('md')} {
      height: 100%;
      width: 100%;
      padding: 56px 12px 47px 12px;
    }
  `
);

const Image = styled.img`
  height: 93px;
  width: 86.3px;
`;

const Title = styled.h2(
  ({ theme }) => css`
    width: 264px;
    height: 29px;
    font-size: 20px;
    font-family: Roboto;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    margin: 0 auto;
    color: ${theme.colors.gray800};
  `
);

const SubTitle = styled.h3(
  ({ theme }) => css`
    width: 264px;
    height: 59px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    margin: 13px auto 32px;
    color: ${theme.colors.gray700};
    ${theme.breakpoint('md')} {
      width: unset;
      height: unset;
    }
  `
);

const BlockedAccountModal = ({ fClose, title, subTitle, textClose }) => {
  const { breakpoint } = useBreakpoints();
  const { loguedAs, doLogout } = useAuth();
  const history = useHistory();

  const handleClick = () => {
    if (loguedAs) {
      doLogout();
    }
    history.push(FORGOT_PASSWORD);
  };

  return (
    <Modal
      showCloseButton={false}
      fClose={fClose}
      height={breakpoint === 'xs' ? '387px' : '359px'}
      width={breakpoint === 'xs' ? '312px' : '400px'}
    >
      <Container>
        <Image src={`${publicPath}/warnin_red.svg`} alt="imagen de advertencia" data-testid="Image" />
        <Title data-testid="Title">{title}</Title>
        <SubTitle data-testid="SubTitle">{subTitle}</SubTitle>
        <Button
          data-testid="Button"
          size="large"
          onClick={handleClick}
          style={{
            width: breakpoint === 'xs' ? '156px' : '200px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '32px auto',
          }}
        >
          {textClose}
        </Button>
      </Container>
    </Modal>
  );
};

export default BlockedAccountModal;
